import React from 'react';
import moment from 'moment';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, DatePicker, Icon, Select } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';

import { LOGISTICA_PRODUCTOS_CON_LOTE, SERIE_POR_PRODUCTO } from '../../../../common/types/parametroType'
import auth from '../../../../common/utility/auth';

const { Option } = Select;
export default function DetalleProductoServicioModal(props) {
    const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
    const mostrarSaniProd = mostrarLoteProducto;
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;
    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        key: 'asignar-serie-button',
                        align: 'center',
                        width: (seriePorProducto) ? 90 : 0,
                        fixed: 'left',
                        render: (value, row) => (

                            <span>
                                <div className="custom-options" hidden={seriePorProducto ? false : true}>
                                    <Tooltip placement="top" title="Asignar Serie">
                                        <Button
                                            type="primary"
                                            icon="bars"
                                            size={"small"}
                                            disabled={row.flagAplicarSerie ? false : true}
                                            onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 80,
                        ellipsis: true,
                        fixed: 'left',
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 250,
                        ellipsis: true,
                        fixed: 'left',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    <Tooltip placement="top" title={value}>
                                        {
                                            props.onGetFieldDecorator(`arrNombre[${row.identifier}]`, {
                                                initialValue: value
                                            })(
                                                <Input
                                                    placeholder="Nombre"
                                                    autoComplete="off"
                                                    className="text-left"
                                                    readOnly={true}
                                                    onClick={(e) => props.onChangeNameProduct(row)}
                                                />
                                            )
                                        }
                                    </Tooltip>
                                </Form.Item>
                            )
                        }
                    },
                    {
                        title: (seriePorProducto) ? 'Series' : '',
                        dataIndex: 'detalleSeries',
                        key: 'detalleSeries',
                        width: (seriePorProducto) ? 90 : 0,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <div className={row.flagAplicarSerie ? '' : 'hide'}
                                    onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrDetalleSeries[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrDetalleSeries[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        width: 100,
                        ellipsis: true
                    },
                    {
                        title: 'Nro. Registro Sanitario',
                        width: 120,
                        dataIndex: 'numeroRegistroSanitario',
                        key: 'numeroRegistroSanitario',
                        className: mostrarSaniProd ? 'show' : 'hide',

                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarSaniProd ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrNumeroRegistroSanitario[${row.identifier}]`, {
                                        initialValue: value
                                    })(
                                        <Input
                                            placeholder="Nro. Registro Sanitario"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrNumeroRegistroSanitario", e.target.value, 0)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Fecha Producción',
                        dataIndex: 'fechaProduccion',
                        key: 'fechaProduccion',
                        align: 'center',
                        className: mostrarSaniProd ? 'show' : 'hide',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarSaniProd ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrFechaProduccion[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                            onChange={(_, value) =>
                                                props.onCalculateDetail(row, "arrFechaProduccion", moment(value, 'DD/MM/YYYY'))
                                            }



                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Fecha Vencimiento',
                        dataIndex: 'fechaVencimiento',
                        key: 'fechaVencimiento',
                        align: 'center',
                        className: mostrarLoteProducto ? 'show' : 'hide',

                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrFechaVencimiento[${row.identifier}]`, {
                                        initialValue: value == null ? null : moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: row.flagVencimiento,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            style={{ border: '1px solid #d9d9d9' }}
                                            allowClear={false}
                                            placeholder="dd/mm/yyyy"
                                            disabled={!row.flagVencimiento}
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                            onChange={(_, value) =>
                                                props.onCalculateDetail(row, "arrFechaVencimiento", moment(value, 'DD/MM/YYYY'))
                                            }
                                            disabledDate={(current) => {
                                                // Deshabilita todas las fechas menores o iguales a hoy
                                                return current && current <= moment().endOf('day');
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Lote',
                        width: 90,
                        dataIndex: 'lote',
                        className: mostrarLoteProducto ? 'show' : 'hide',
                        key: 'lote',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrLote[${row.identifier}]`, {
                                        initialValue: value
                                    })(
                                        <Input
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrLote", e.target.value, 0)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Tipo IGV',
                        dataIndex: 'idImpuesto',
                        key: 'idImpuesto',
                        width: 220,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridImpuesto[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo IGV"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onCalculateDetail(row, "arridImpuesto", option.key, 5); }}
                                        >
                                            {props.tipoAfectacion.map(item => (
                                                ['10', '20', '30', '40'].includes(item.codigoSunat) ?
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option> :
                                                    null
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Valor Unitario',
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={props.precioUnitarioDisabled}
                                            placeholder="V.  Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Precio Unitario',
                        dataIndex: 'precioNuevo',
                        key: 'precioNuevo',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecio[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="P. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPrecio", e.target.value, 5)}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 100,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(3),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={row.flagAplicarSerie ? true : false}
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrCantidad", e.target.value, 3)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrSubTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'center',
                        width: 80,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrIgv[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={props.totalDisabled}
                                            placeholder="Total"
                                            autoComplete="off"
                                            className="text-right"

                                            onBlur={(e) => props.onCalculateDetail(row, "arrTotal", e.target.value, 2)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
                ]}
            />
        </div>
    );
}